<template>
  <div class="my-dialog_containter">
    <el-dialog
      :visible.sync="isVisible"
      :width="`${width}`"
      @open="open"
      @close="close"
      :before-close="closeDialogBefore"
      :append-to-body="appendToBody"
      :class-name="customClass"
      :close-on-click-modal="closeOnClickModal"
    >
      <div slot="title" v-show="isShowHeader">
        <!-- 头部自定义 -->
        <slot name="header">
          <div class="dialog_header" v-if="!_.isEmpty(title)">{{ title }}</div>
        </slot>
      </div>
      <main>
        <!-- 主要内容放这里 -->
        <slot name="body"></slot>
      </main>
      <div slot="footer" class="footer">
        <!-- 自定义底部按钮 -->
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * MyDialog 弹窗组件
 * isOpen 是否开启
 * isShowHeader 是否展示头部
 * title 标题
 */
export default {
  name: "MyDialog",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    isShowHeader: {
      type: Boolean,
      default: true,
    },
    title: {
      type: [String, null],
      default: null,
    },
    width: {
      type: [String],
      default: "50%",
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    isOpen: function (val) {
      this.isVisible = val;
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
      this.$emit("callback");
    },
    closeDialogBefore(done) {
      this.$emit("closeBefore");
      done();
    },
  },
};
</script>
<style lang="less" scoped>

::v-deep .dialog_header {
  display: flex;
  align-items: center;
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  font-weight: 600;
  color: #1f2d3d;
}
::v-deep .dialog_header::before {
  content: "";
  display: block;
  background-color: #409EFF;
  height: 19px;
  width: 4px;
  margin-right: 8px;
}
.my-dialog_containter {
  ::v-deep .el-dialog__header {
    padding: 18px 0;
  }
  ::v-deep .el-dialog__close {
    color: #c4c4c4;
    font-size: 18px;
  }
  ::v-deep .el-dialog__body {
    padding: 0 20px;
  }
  .footer {
    display: flex;
    justify-content: center;
  }
}
</style>
